import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing, palette, breakpoints }) =>
  createStyles({
    table: {
      borderCollapse: 'separate',
      borderSpacing: '0 0.8rem',
      marginBottom: spacing(4),

      '& > thead > tr > th': {
        border: 'none',
        paddingTop: 0,
        paddingBottom: spacing(0.5),

        '&:first-child': {
          paddingLeft: spacing(0.4),
        },

        '& .MuiTypography-h3': {
          fontSize: '1.6rem',
        },
      },
    },
    row: {
      width: '100%',
      '& td': {
        backgroundColor: palette.background.default,
        paddingTop: spacing(1.1),
        paddingBottom: spacing(1.1),
        borderBottom: '0px solid ' + palette.divider,

        '& button': {
          backgroundColor: '#CECFCE',

          '&:hover': {
            backgroundColor: '#a2a3a2',
          },
        },
        '&:first-child': {
          [breakpoints.up('sm')]: {
            maxWidth: '6rem',
          },
          color: 'var(--text-title)',
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
        },
        '&:last-child': {
          borderTopRightRadius: 5,
          borderBottomRightRadius: 5,
          width: '0',
        },
      },
    },
  }),
)
